import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Divider,
} from "@mui/material";
import { LinkedIn } from "@mui/icons-material";
import logo from '../assets/images/companylogo.png'
// import logo from '../assets/images/footlogo.png'

// ✅ Custom Icon Components
const FacebookIcon = () => (
  <img
    src="https://cdn-icons-png.flaticon.com/512/145/145802.png"
    alt="Facebook"
    style={{ width: 24, height: 24 }}
  />
);

const YouTubeIcon = () => (
  <img
    src="https://cdn-icons-png.flaticon.com/512/1384/1384060.png"
    alt="YouTube"
    style={{ width: 24, height: 24 }}
  />
);

const InstagramIcon = () => (
  <img
    src="https://cdn-icons-png.flaticon.com/512/1384/1384063.png"
    alt="Instagram"
    style={{ width: 24, height: 24 }}
  />
);

export default function Footer() {
  return (
    <Box
      sx={{
        // background  : "linear-gradient(to bottom right, #7AB2D3, #8ae97d )",
        // background: "#0B0C10",
        background: " #3A7C6C",
        "&:hover": {
          background: "linear-gradient(to bottom right, #03644c, #3A7C6C)",
        },
        color: "#E0E1DD",
        pt: 8,
        pb: 4,
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      <Container maxWidth="lg">
        {/* Company Logo */}

        {/* <Typography
            variant="h6"
            sx={{ fontWeight: "bold", mt: 1, fontSize: 24 }}
          >
            Claysoft
          </Typography> */}

        {/* Grid with Contact and Quick Links */}
        <Grid container spacing={4}>
          {/* Contact Info (Left) */}
          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: "left" }}>
              <Typography sx={{
                fontSize: 16, lineHeight: 2, fontWeight: 500,
                textTransform: "uppercase", letterSpacing: 1.5, fontFamily: 'Merriweather, serif'
              }}>
                CLAYSOFT SOLUTIONS PVT. LTD.
                <br />
                Gurugram, India
                <br />
                sales@claysoft.in
                <br />
                +91 9120833144
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box
              sx={{
                textAlign: "center",
                marginLeft: { xs: "4px", md: "160px" },
                marginRight: { xs: "6px", md: "200px" },

              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: "rgba(255,255,255,0.1)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255,255,255,0.3)",
                  borderRadius: "45px",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                  width: 260,
                  height: 140,
                  mx: "auto",
                  transition: "0.4s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: "0 12px 36px rgba(0,0,0,0.25)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={logo}
                  alt="Claysoft Logo"
                  sx={{ width: 180, height: 80 }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: 12,
                    color: "#fff",
                    opacity: 0.7,
                    mt: 1,
                    fontStyle: "italic",
                  }}
                >
                  Empowering Logistics Digitally
                </Typography>
              </Box>


            </Box>

          </Grid>

          {/* Quick Links (Right) */}
          <Grid item xs={12} md={4}>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "flex-start", md: "flex-end" },
                gap: 1,
              }}
            >
              {["Home", "About", "Services", "Contact"].map((text) => (
                <Link
                  key={text}
                  href={`${text.toLowerCase()}`}
                  underline="hover"
                  color="inherit"
                  sx={{
                    fontSize: 16,
                    lineHeight: 2,
                    fontWeight: 500,
                    textTransform: "uppercase",
                    letterSpacing: 1.5,
                    fontFamily: 'Merriweather, serif',
                    transition: "0.3s",
                    "&:hover": {
                      color: "#7AB2D3",
                      pl: 1,
                    },
                  }}
                >
                  {text}
                </Link>
              ))}
            </Box>
          </Grid>
        </Grid>

        {/* Social Media Icons */}
        <Box sx={{ textAlign: "center", mt: 5 }}>
          {[FacebookIcon, YouTubeIcon, InstagramIcon, LinkedIn].map(
            (Icon, i) => (
              <IconButton
                key={i}
                href="#"
                sx={{
                  color: "#E0E1DD",
                  mx: 1,
                  transition: "0.3s",
                  "&:hover": { color: "#7AB2D3", transform: "scale(1.2)" },
                }}
              >
                <Icon />
              </IconButton>
            )
          )}
        </Box>

        {/* About Paragraph */}
        <Box sx={{ mt: 4, textAlign: "center", maxWidth: 800, mx: "auto" }}>
          <Typography variant="body2" sx={{ fontSize: 14, opacity: 0.7, fontFamily: 'Merriweather, serif', }}>
            Claysoft acknowledges the brilliant minds and digital innovators
            that shape the future. We’re passionate about technology, committed
            to quality, and inspired by progress. Thank you for being a part of
            our journey.
          </Typography>
        </Box>

        {/* Divider */}
        <Divider sx={{ my: 4, borderColor: "#2B2D42" }} />

        {/* Bottom Legal Links */}
        {/* <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            textAlign: "center",
            px: 2,
            gap: 2,
          }}
        >
          <Link href="#" underline="hover" sx={{ color: "#E0E1DD" }}>
            Terms and Conditions
          </Link>
          
          <Link href="#" underline="hover" sx={{ color: "#E0E1DD" }}>
            Privacy Policy
          </Link>
        </Box> */}

        {/* Bottom Copyright */}
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <Typography variant="body2" sx={{ fontSize: 13, opacity: 0.6 }}>
            © 2018 - {new Date().getFullYear()} Claysoft. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
